import PropTypes from 'prop-types';

export const productTypesListPT = PropTypes.arrayOf(PropTypes.exact({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    uri_param: PropTypes.string,
}));


